import React from 'react';
import ARefreshControl from 'antd-mobile/lib/refresh-control';



export default class RefreshControl extends ARefreshControl {}